import type {MergeConditionWithSubConditionsPayload} from '../page-data/payloads/merge-box'
import {USER_CANNOT_PUSH_SUBCONDITION} from './json-api-helpers'

type AgentMergeVisibility = {
  isOpen: boolean
  isFeatureEnabled: boolean
  userStateCondition: MergeConditionWithSubConditionsPayload | undefined
  isUserBlockedFromPushing: boolean
  isConfirmingMergeInfo: boolean
  isStacked: boolean
}

function canUserUseAgentMerge(userStateCondition: MergeConditionWithSubConditionsPayload | undefined) {
  return (
    !!userStateCondition &&
    userStateCondition.result !== 'UNKNOWN' &&
    !userStateCondition.failedSubConditions.some(
      subCondition => subCondition.displayName === USER_CANNOT_PUSH_SUBCONDITION,
    )
  )
}

export function shouldShowAgentMerge({
  isOpen,
  isFeatureEnabled,
  userStateCondition,
  isUserBlockedFromPushing,
  isConfirmingMergeInfo,
  isStacked,
}: AgentMergeVisibility) {
  return (
    isOpen &&
    isFeatureEnabled &&
    canUserUseAgentMerge(userStateCondition) &&
    !isUserBlockedFromPushing &&
    !isConfirmingMergeInfo &&
    !isStacked
  )
}
